"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _AccountCircle2 = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _MenuItem2 = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuCollaborator = function MenuCollaborator(_ref) {
  var anchorEl = _ref.anchorEl,
      onClose = _ref.onClose,
      onSelect = _ref.onSelect,
      data = _ref.data,
      isLoading = _ref.isLoading;

  var handleClose = function handleClose() {
    onClose(null);
  };

  var handleClick = function handleClick(item) {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(item);
    handleClose();
  };

  return /*#__PURE__*/React.createElement(_Menu2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    getContentAnchorEl: null,
    variant: "menu",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, isLoading && /*#__PURE__*/React.createElement(_MenuItem2["default"], {
    style: {
      minWidth: 200
    }
  }, /*#__PURE__*/React.createElement(_CircularProgress2["default"], null)), Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.map(function (item) {
    return /*#__PURE__*/React.createElement(_MenuItem2["default"], {
      key: item.id,
      style: {
        minWidth: 200
      },
      onClick: function onClick() {
        return handleClick(item);
      }
    }, /*#__PURE__*/React.createElement(_Chip2["default"], {
      size: "small",
      label: "".concat(item.name),
      icon: /*#__PURE__*/React.createElement(_AccountCircle2["default"], {
        style: {
          color: item.color || "#20C933"
        }
      })
    }));
  })));
};

MenuCollaborator.propTypes = {
  anchorEl: _propTypes["default"].object,
  onClose: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    color: _propTypes["default"].string
  }))
};
var _default = MenuCollaborator;
exports["default"] = _default;